import { IsObject, IsString } from '../../validators';
import { ApiProperty } from '../../codegen';

export class SettingsDto {
  @ApiProperty()
  @IsString()
  stripePublicKey: string;

  @ApiProperty()
  @IsObject()
  billingPricing: Record<string, unknown>;

  @ApiProperty()
  @IsString()
  PUBLIC_WEB_PUSH_VAPID_KEY: string;
}
